import {
    FETCH_EVENTS,
    FETCH_EVENTS_SUCCESS,
    FETCH_EVENTS_FAILED,
    EDIT_EVENT
} from "../store/types";

const INITIAL_STATE = {
    events: null,
    loading: false,
    error: {
        flag: false,
        msg: null
    }
}

export const eventlistreducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case FETCH_EVENTS:
            return {
                ...state,
                loading: true
            };
        case FETCH_EVENTS_SUCCESS:
            return {
                ...state,
                events: action.payload,
                loading: false
            };
        case FETCH_EVENTS_FAILED:
            return {
                ...state,
                events: null,
                loading: false,
                error: {
                    flag: true,
                    msg: action.payload
                }
            };
        case EDIT_EVENT:
            return state;
        default:
            return state;
    }
};